<template>
  <div id="MainHeader">
    <div class="barra_superior" />
    <header class="cabecalho">
      <img
        alt="truckme"
        src="/static/img/logo.png"
        class="logo_dashboard wow bounce"
        data-wow-delay="0s"
        style="visibility: visible; animation-delay: 0s; animation-name: bounce;"
      >


      <div class="botoes_cabecalho">
        <div class="no-mobile">
          <p class="regular t12">
            Olá,&nbsp;
          </p>
          <p class="negrito t12">
            {{ getUsuario.nome }}
          </p>
        </div>

        <div>
          <el-popover
            placement="bottom"
            width="200"
            trigger="click"
          >
            <div class="usuario no-desktop">
              <p class="regular t12">
                Olá,&nbsp;
              </p>
              <p class="negrito t12">
                {{ getUsuario.nome }}
              </p>
            </div>
            <hr class="no-desktop">
            <a
              href="#"
              @click.prevent="handleAlterarSenha(true)"
              class="texto-vermelho"
            >Alterar Senha</a>
            <hr>
            <a
              href="#"
              @click="handleLogoff()"
              class="texto-vermelho"
            >Sair</a>
            <i
              slot="reference"
              class="fa fa-bars texto-vermelho"
              style="font-size:24px;width:30px;text-align: center;"
            />
          </el-popover>
        </div>
      </div>
    </header>

    <AlterarSenha
      :visible="visible"
      @visible="handleAlterarSenha(false)"
    />
  </div>
</template>

<script>
import AlterarSenha from './AlterarSenha'
import { mapGetters } from 'vuex'

export default {
  name: 'MainHeader',
  components: {
    AlterarSenha
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters({
      getUsuario: 'getUsuario',
      getPerfil: 'getPerfil'
    }),
    perfil: function () {
      let perfil = ''

      switch (this.getPerfil) {
        case 'G':
        case 'O':
          perfil = 'EMBARCADOR'
          break;
        case 'A':
          perfil = 'ADMINISTRADOR TRUCKME'
          break;
        default:
          perfil = '-'
          break;
      }
      return perfil
    }
  },
  methods: {
    handleLogoff() {
      this.$store.dispatch('cleanSingleSourceOfTruth')
      this.$router.push({ name: 'Login' })
    },
    handleAlterarSenha(value) {
      this.visible = value
    }
  }
}
</script>

<style>
#MainHeader .barra_superior {
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
}
#MainHeader header {
  height: 87px;
}
#MainHeader .cabecalho img.logo_dashboard {
  width: 80px;
  margin-top: 10px ;
}
#MainHeader .cabecalho img.foto_usuario {
  width: 40px;
  margin-top: 7px;
}
#MainHeader .logoff {
  cursor: pointer;
}
#MainHeader .logoff .usuario {
  margin: 20px 20px 20px 20px;
}
#MainHeader .logoff:hover p {
  color: #DC2626 !important;
  font-weight: bold;
}

#MainHeader .cabecalho .botoes_cabecalho {
  display:flex;
  flex-direction:row;
  align-content: center;
  align-items: center;
  height: 100%;
}
#MainHeader .cabecalho .botoes_cabecalho div:first-child {
  display:flex;
  align-content: center;
  align-items: center;
  margin-right: 15px;
}

.no-desktop {
  display: none !important;
}

@media screen and (max-width: 768px) {
  #MainHeader .cabecalho{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top:10px;
    padding-bottom:10px;
  }

  #MainHeader .no-mobile {
    display: none !important;
  }

  .no-desktop {
    display: block !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/MainHeader.vue